module.exports = __webpack_public_path__ + "static/media/SmartShop_7-713w.a778cb23.webp";